import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiX, FiUsers, FiMessageCircle, FiImage, FiType, FiCheck } = FiIcons;

const CreateGroupModal = ({ isOpen, onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: 'General Support',
    description: '',
    whatsappLink: '',
    image: 'https://images.unsplash.com/photo-1516589174184-c685ca33d2b0?q=80&w=2070&auto=format&fit=crop'
  });

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate({ ...formData, id: Date.now(), memberCount: 1, creator: "You", isVerified: false });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-accent-navy/60 backdrop-blur-md">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-[40px] shadow-2xl w-full max-w-xl overflow-hidden border border-brand-dark"
      >
        <div className="p-8 md:p-10">
          <div className="flex justify-between items-center mb-8">
            <h3 className="text-3xl font-serif text-accent-navy">Start a Community</h3>
            <button onClick={onClose} className="p-2 hover:bg-brand-light rounded-full text-text-muted">
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy">Group Name</label>
              <div className="relative">
                <SafeIcon icon={FiUsers} className="absolute left-4 top-1/2 -translate-y-1/2 text-accent-gold" />
                <input 
                  required
                  className="w-full pl-12 pr-4 py-4 bg-brand-light border-2 border-brand-dark rounded-2xl focus:border-accent-gold outline-none"
                  placeholder="e.g. Veterans Remembrance Circle"
                  value={formData.name}
                  onChange={e => setFormData({...formData, name: e.target.value})}
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy">Description</label>
              <textarea 
                required
                className="w-full px-4 py-4 bg-brand-light border-2 border-brand-dark rounded-2xl focus:border-accent-gold outline-none h-32 resize-none"
                placeholder="What is the purpose of this group?"
                value={formData.description}
                onChange={e => setFormData({...formData, description: e.target.value})}
              />
            </div>

            <div className="space-y-2">
              <label className="text-[10px] font-black uppercase tracking-widest text-accent-navy">WhatsApp Group Link (Optional)</label>
              <div className="relative">
                <SafeIcon icon={FiMessageCircle} className="absolute left-4 top-1/2 -translate-y-1/2 text-green-500" />
                <input 
                  className="w-full pl-12 pr-4 py-4 bg-brand-light border-2 border-brand-dark rounded-2xl focus:border-accent-gold outline-none"
                  placeholder="https://chat.whatsapp.com/..."
                  value={formData.whatsappLink}
                  onChange={e => setFormData({...formData, whatsappLink: e.target.value})}
                />
              </div>
            </div>

            <button type="submit" className="w-full btn-primary py-5 text-lg flex items-center justify-center gap-3 shadow-xl">
              Create Sanctuary Group <SafeIcon icon={FiCheck} />
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default CreateGroupModal;